import React, { useEffect, useState, useContext} from 'react'
import firebase from '../config/firebase.js';
import { AuthContext } from '../Auth.js'


import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Moment from 'react-moment';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function TurnForm (payload) { 

    const [preferencias, setPreferencias] = useState(null);
    const [turno, setTurno] = useState(null);
    const {currentUser, userProfile} = useContext(AuthContext);
    const [terminosAceptados, setTerminosAceptados] = useState(false)
    const classes = useStyles();
  
    const handleChange = () => {
      if (!terminosAceptados) {
        setTerminosAceptados(true);
      } else {
        setTerminosAceptados(false);
      }
    }

    const ConfirmarVoluntariado = () => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      
      const uidRef = db.collection('users').doc(currentUser.uid)
      const id = payload.turnoVol.id
      const volTurnoRef = uidRef.collection('turnos').doc(id)
      const turno = {
        'verificado' : true
      }
      const diaTurno = payload.turnoVol.id.split("_");
      const turnoRef = db.collection('dias').doc(diaTurno[0]).collection('turnos').doc(diaTurno[1]);
      const volRef = turnoRef.collection('voluntarios').doc(currentUser.uid);
      const voluntario = {
          'verificado' : true
      } 
     
      return firebase.firestore().runTransaction(function(transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(turnoRef).then(function(turnoDoc) {
              if (!turnoDoc.exists) {
                  throw "Turno  does not exist!";
              }
              transaction.update(volRef, voluntario);   
              transaction.update(volTurnoRef, turno);
            })
      }).then(function() {
      }).catch(function(error) {
          console.log("Transaction failed: ", error);
      });
    
    }

    const BajarVoluntariado = () => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      
      const uidRef = db.collection('users').doc(currentUser.uid)
      const id = payload.turnoVol.id
      const volTurnoRef = uidRef.collection('turnos').doc(id)
     
      const diaTurno = payload.turnoVol.id.split("_");
      const turnoRef = db.collection('dias').doc(diaTurno[0]).collection('turnos').doc(diaTurno[1]);
      const volRef = turnoRef.collection('voluntarios').doc(currentUser.uid);
        
      var auditRef    = db.collection('audits').doc()
      var audit = {
          'userId'        : currentUser.uid,
          'userNombre'    : userProfile.nombre + " " + userProfile.apellido,
          'created'       : firebase.firestore.FieldValue.serverTimestamp(),
          'movimiento'    : "Cancelar reserva",
          'dia'           : diaTurno[0], 
          'turno'         : diaTurno[1],
          'voluntarioId'  : currentUser.uid
      }

      return firebase.firestore().runTransaction(function(transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(turnoRef).then(function(turnoDoc) {
              if (!turnoDoc.exists) {
                  throw "Turno  does not exist!";
              }
              transaction.delete(volRef);   
              transaction.delete(volTurnoRef);
              transaction.set(auditRef, audit);
            })
      }).then(function() {
      }).catch(function(error) {
          console.log("Transaction failed: ", error);
      });
  
    }

    

    useEffect(() => {
    
      const fetchData = async () => {
        const db = firebase.firestore().collection('orgs').doc('unidos');
        const diaTurno = payload.turnoVol.id.split("_");
        db.collection("dias")
        .doc(diaTurno[0])
        .get()
        .then(function(docDia) {
          if (docDia.exists) {
            db.collection("dias")
              .doc(diaTurno[0])
              .collection('turnos').doc(diaTurno[1])
              .get()
              .then(function(docTurno) {
                  if (docTurno.exists) {
                      setTurno({...docTurno.data(), ...docDia.data()});
                      db.get()
                      .then(function(doc) {
                          if (doc.exists) {
                              setPreferencias({...doc.data()});
                          } else {
                              console.log("no existen la organizacion")
                          }
                      });
                  } else {
                      console.log("no existe")
                  }
              });
          }
        }) 
     };
      
     fetchData();
    }, []);

    if (!turno)
    return (
      <div>
        Loading

      </div>
    ) 
      
    if (!preferencias)
    return (
      <div>
        Loading

      </div>
    ) 


  const dia = turno.fecha.toDate();
  console.log( preferencias.verificacion)
  return (
      <>
         <Grid container spacing={2}>
        <Grid item xs={12}>
        <Typography component="h1" variant="h5">
          Términos y condiciones
        </Typography>
        </Grid>
        <Grid item xs={12}>
        <p>
        Necesitamos su confirmación para asistir al turno de voluntariado 
        del <b><Moment format="DD">{dia}</Moment> de <Moment format="MMMM">{dia}</Moment></b> 
        en el horario de <b>{turno.horario}</b>.
        </p>
        <p>
        Solicitamos confirmar su asistencia leyendo y aceptando los términos y condiciones.
        </p>
        <ul>
          { preferencias.verificacion.condiciones.map( (condicion,index) => (<li key={index} >{condicion}</li>)) }
        </ul>
        <p>{preferencias.verificacion.recordatorio}</p>
        </Grid>
        <Grid item xs={12}>
        <FormControlLabel
            control={
              <Checkbox value="check" onChange={handleChange} />
            }
            label="He leído y acepto los términos y condiciones"
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            disabled={!terminosAceptados}
            className={classes.submit}
            onClick={ConfirmarVoluntariado}
          >
            Confirmar asistencia 
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            onClick={BajarVoluntariado}
            className={classes.submit}
          >
            No, cancelar mi reserva
          </Button>
        </Grid>
        </Grid>
      </>
    )
  
};
 

export default TurnForm; 
